import { AiOutlineFieldTime } from "react-icons/ai";
import { BsTags } from "react-icons/bs";
import { FiSettings, FiUsers } from "react-icons/fi";
import { FaDatabase, FaProjectDiagram } from "react-icons/fa";
import { RxDashboard, RxStopwatch, RxIdCard, RxGlobe } from "react-icons/rx";
import { TbBrandUnity } from "react-icons/tb";
import { FaUsersGear } from "react-icons/fa6";

export const navLinks = (isScaled: any) => {
  return (
    [
      {
        isExternal: false,
        to: "/dashboard",
        icon: <RxDashboard size={isScaled ? 18 : 20} />,
        text: "Dashboard",
      },
      {
        isExternal: false,
        to: "/3d-dashboard",
        icon: <TbBrandUnity size={isScaled ? 18 : 20} />,
        text: "3D Plant",
      },
      {
        isExternal: false,
        to: "/dashboard-configuration",
        icon: <BsTags size={isScaled ? 18 : 20} />,
        text: "Tags",
      },
      {
        isExternal: false,
        to: "/alarms",
        icon: <RxStopwatch size={isScaled ? 18 : 20} />,
        text: "Alarms",
      },
      {
        isExternal: false,
        to: "/tickets",
        icon: <RxIdCard size={isScaled ? 18 : 20} />,
        text: "Tickets",
      },
      {
        isExternal: false,
        to: '/data-sources',
        icon: <FaDatabase size={isScaled ? 18 : 20} />,
        text: 'Data Sources'
      },
      // {
      //   isExternal: false,
      //   to: "/users",
      //   icon: <FiUsers size={isScaled ? 18 : 20} />,
      //   text: "Users",
      // },
      {
        isExternal: false,
        to: "/logs",
        icon: <AiOutlineFieldTime size={isScaled ? 18 : 20} />,
        text: "Logs",
      },
      {
        isExternal: false,
        to: "/projects",
        icon: <FaProjectDiagram size={isScaled ? 18 : 20} />,
        text: "Projects",
      },
      {
        isExternal: false,
        to: "/users-and-projects",
        icon: <FaUsersGear size={isScaled ? 18 : 20} />,
        text: "Users and Projects",
      }
    ]

  );
};